export const AuthConstants = {
  keyAccessToken: 'access',
  keyRefreshToken: 'refresh',
};
